// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as GemMlExtended } from '../../../../../ui-v3/src/assets/icons/extended/entities/gem-ml.svg?react';
import { createIcons } from '../../Icon';
const GemMlIcon = /* @__PURE__ */ createIcons('GemMl', {
    extended: GemMlExtended
});
GemMlIcon.supportedTypes = [
    'extended'
];
GemMlIcon.category = 'entities';
export default GemMlIcon;
